<template>
	<div :class="$style.subbar">
		<ul :class="$style.breadcrumbs" class="mr-0 mr-sm-4">
			<li v-for="(item, i) in breads" :key="`bread-${i}`" :class="$style.breadcrumb">
				<router-link v-if="item.url" :to="item.url" :class="[$style.breadcrumbLink]">
					<fa-icon v-if="item.icon" class="mr-2" :icon="item.icon" /> {{ item.name }}
				</router-link>
				<span v-else :class="[$style.breadcrumb]">
					<fa-icon v-if="item.icon" class="mr-2" :icon="item.icon" /> {{ item.name }}
				</span>
			</li>
			<!-- <li v-for="(item, i) in breads" :key="`bread-${i}`" :class="$style.breadcrumb">
				<router-link :to="{name: '_users'}" :class="[$style.breadcrumbLink, $style.breadcrumbLink__current]">
					<fa-icon v-if="item.icon" class="mr-2" :icon="item.icon" /> {{ item.name }}
				</router-link>
			</li> -->
			<li :class="[$style.breadcrumb, $style.breadcrumbLink__current]">
				<fa-icon v-if="$route.meta.icon" class="mr-2" :icon="$route.meta.icon" />
				<a :class="[$style.breadcrumbLink , $style.breadcrumbLink__truncate]">{{ $title }}</a>
			</li>
		</ul>

		<template v-if="$postUrl">
			<a-tooltip :open="tooltipVisible">
				<template #title>
					Enlace copiado
				</template>
				<a-button @click="copyToClipboard">
					<fa-icon class="mr-2" :icon="['far', 'clipboard']" />
					Copiar enlace
				</a-button>
			</a-tooltip>
			<textarea id="tocopy" v-model="$postUrl" style="height:0;position:absolute;z-index: -1;opacity:0.1;" />
		</template>
		<a-button v-if="$route.name === 'postEdit'" :loading="loadingDupliPost" class="mx-2" @click="dupliPost">
			<a-icon type="copy" />
			Duplicar post
		</a-button>
		<div :class="$style.divider" class="mr-2 d-none d-xl-block" />

		<!-- <p class="color-gray-4 text-uppercase font-size-18 mb-0 mr-4 d-none d-xl-block">
			INV-00125
		</p> -->

		<template v-if="$route.meta.topbar">
			<div class="ml-2 ml-sm-0 mr-sm-auto">
				<a-button v-for="(b,i) in buttons" :key="`btn-${i}`" :variant="b.variant" :class="b.class" @click="$hub.emit(b.event);">
					<span v-if="b.icon" class="mr-2">
						<fa-icon :icon="b.icon" />
					</span>
					{{ b.text }}
				</a-button>
			</div>
		</template>
		<!-- <div :class="$style.amount" class="mr-3 ml-auto d-none d-sm-flex">
			<p :class="$style.amountText">
				This month
				<span :class="$style.amountValue">$251.12</span>
			</p>
			<div :class="$style.amountGraph">
				<i :class="$style.amountGraphItem" :style="{ height: '80%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '70%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '60%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
			</div>
		</div>

		<div :class="$style.amount" class="d-none d-sm-flex">
			<p :class="$style.amountText">
				Last month
				<span :class="$style.amountValue">$12,256.12</span>
			</p>
			<div :class="$style.amountGraph">
				<i :class="$style.amountGraphItem" :style="{ height: '60%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '75%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '55%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '100%' }" />
				<i :class="$style.amountGraphItem" :style="{ height: '85%' }" />
			</div>
		</div> -->
	</div>
</template>

<script>
/* eslint-disable import/extensions */
import { h } from 'vue';
import _ from 'lodash';

import YOURLS from 'node-yourls-api';

const micholloto = new YOURLS('http://mc.to/yourls-api.php');

micholloto.login('897b260227');

export default {
	data() {
		return {
			breads: null,
			tooltipVisible: false,
			loadingDupliPost: false,
		};
	},
	computed: {
		buttons() {
			const { buttons } = this.$route.meta.topbar;

			const result = [];
			if (buttons) {
				buttons.forEach((b) => {
					result.push({
						text: b.text,
						icon: b.icon,
						event: b.event ? b.event : '_topbarButtonClick',
						variant: b.variant,
						class: b.class,
					});
				});
			}

			return result;
		},
	},
	watch: {
		$route(to) {
			this.breads = to.meta.breads;
		},
	},
	created() {
		this.breads = this.$route.meta.breads;
	},
	methods: {
		copyToClipboard() {
			if (!this.tooltipVisible) {
				this.tooltipVisible = true;
				setTimeout(() => { this.tooltipVisible = false; }, 1000);
			}
			document.getElementById('tocopy').value = `${document.getElementById('tocopy').value}/`;
			const input = document.getElementById('tocopy');
			input.select();
			document.execCommand('copy');
		},
		async dupliPost() {
			if (this.$route.params.id) {
				const dealId = this.$route.params.id;

				this.loadingDupliPost = true;

				const deal = await this.$sdk.deals().get(dealId);

				if (deal.ok) {
					if (this.$route.params.id === dealId) {
						const params = {
							created_at: deal.data.created_at,
							offer_url: deal.data.offer_url,
							name: deal.data.name,
							status: 'pending',
							old_price: deal.data.old_price ? deal.data.old_price.replace(',', '.') : null,
							sale_price: (deal.data.sale_price || deal.data.sale_price === 0) ? deal.data.sale_price.toString().replace(',', '.') : null,
							tags: deal.data.tags ? deal.data.tags : [],
							image_url: deal.data.image_url,
							description: deal.data.description,
							// user_id: deal.data.user.id,
							user_id: null,
							coupons: deal.data.coupons || [],
							gallery: deal.data.gallery || [],
							updated_at: deal.updated_at,
							promoted: deal.data.promoted,
							adult: deal.data.adult,
							notify: false,
						};

						if (deal.data.store) {
							deal.data.store.forEach((store) => {
								const dataStore = {
									id: store.id,
									name: store.name,
									type: 'store',
								};

								params.tags.push(dataStore);
							});
						}

						const data = _.cloneDeep(params);

						console.log({ data });

						const post = {
							...data,
							sale_price: (data.sale_price || data.sale_price === 0) ? (data.sale_price * 100) : null,
							old_price: (data.old_price || data.old_price === 0) ? (data.old_price * 100) : null,
						};

						console.log({ post });

						if (post.tags) post.tags = post.tags.map(t => t.id);
						if (post.created_at) post.created_at = this.$moment(post.created_at).format();

						Object.keys(post).forEach((key) => {
							if (post[key] === null) delete post[key];
							if (typeof post[key] === 'object' && (post[key] === null || post[key].length === 0)) delete post[key];
						});

						let errorPost = false;

						// Busca si es Aliexpress o AliexpressPlaza
						if (post.tags && post.tags.find(d => d === 6 || d === 48)) {
							try {
								// Revisar si la url sigue viva
								// if (revisarUrl && revisarUrl.error && revisarUrl.error.response && revisarUrl.error.response.status === 404) {
								// 	this.$message.error({ content: 'El post no se puede duplicar', duration: 2.5 });
								// 	errorPost = true;
								// }	else {
								// Cambiar fecha de forma aleatorio
								const randomMin = Math.floor(Math.random() * 59) + 1;
								const randomHour = Math.floor(Math.random() * 23) + 0;
								const minDay = 1;
								const maxDay = this.$moment().daysInMonth();
								const month = this.$moment().get('month') + 1;
								const year = this.$moment().get('year');
								const randomDay = Math.floor(Math.random() * maxDay) + minDay;

								post.created_at = this.$moment(`${year}-${month}-${randomDay} ${randomHour}:${randomMin}`, 'YYYY-MM-DD HH:mm').format();

								// User de forma aleatoria
								const { data: usersFakeData } = await this.$http.get('https://app.michollo.com/api/admin/users_fake', { Authorization: false });

								if (usersFakeData.ok) {
									const {
										users: { results },
									} = usersFakeData;

									const usersFakes = results.filter(d => d.id !== 95136 && d.id !== 16333);

									if (usersFakes.length === 0) {
										post.user_id = this.user.id;
									} else {
										post.user_id = usersFakes[Math.floor(Math.random() * usersFakes.length)].id;
									}
								}

								// Actualizar precio
								try {
									// const { data: { url } } = await this.$axios.get(`https://app.michollo.com/api/short_url/?keyword=${keyword}`);
									const matchKeyword = post.offer_url.match(/(https:\/\/[a-z]\.michollo\.to\/)([a-z1-9]+)/i);

									if (matchKeyword) {
										const { data: { url } } = await this.$axios.get(`https://app.michollo.com/api/short_url/?keyword=${matchKeyword[1]}`);

										if (url) {
											const { data: { data: { item } } } = await this.$http.get(`https://autocompleter.michollo.com/autocompleter?u=${url}`);

											if (item.stock === false) {
												this.$message.error({ content: 'El producto no está disponible', duration: 5 });
												errorPost = true;
											} else if (item.old_price && item.price) {
												this.$message.success({ content: 'El precio anterior y nuevo se ha actualizado', duration: 2.5 });
											}	else if (!item.old_price && item.price) {
												this.$message.success({ content: 'El precio nuevo se ha actualizado', duration: 2.5 });
											}	else if (item.old_price && !item.price) {
												this.$message.success({ content: 'El precio anterior se ha actualizado', duration: 2.5 });
											}	else {
												this.$message.error({ content: 'No se ha podido actualizar los precios', duration: 5 });
												// errorPost = true;
											}

											if (item.old_price || item.old_price === 0) post.old_price = item.old_price * 100;
											if (item.price || item.price === 0) post.sale_price = item.price * 100;
										}
									}	else {
										this.$message.error({ content: 'No se ha podido actualizar los precios', duration: 5 });
									}
								} catch (error) {
									this.$message.error({ content: 'No se ha podido actualizar los precios', duration: 5 });
									console.log(error);
								}

								// Post activo
								post.status = 'pending';
							} catch (error) {
								this.$message.error({ content: 'El post no se puede duplicar', duration: 2.5 });
								errorPost = true;
								// return false;
							}
						}

						if (!errorPost) {
							const result = await this.$sdk.deals().add(post, true);

							if (this.$route.params.id !== result.id) {
								this.$message.success({ content: () => h('span', 'Post duplicado correctamente'),
									duration: 2.5 });

								this.$router.push({ name: 'postEdit', params: { id: result.id } });
							}
						}
					}
				} else {
					this.$message.error({ content: 'El post a duplicar no existe', duration: 2.5 });
				}

				this.loadingDupliPost = false;
			}
		},

		redirectPostCreate(id) {
			this.$router.push({ name: 'postEdit', params: { id } });
			return true;
		},

		async getLastUrl(url) {
			const options = {
				method: 'GET',
				max_depth: 20,
				headers: {
					'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:62.0) Gecko/20100101 Firefox/62.0',
				},
			};

			try {
				const res = await this.unshort(url, options);

				// const text = res[res.length - 1];

				console.log({ res }, res.response);
				return res;
			} catch (error) {
				console.log({ error }, error.response);
			}

			return false;
		},
		async unshortOneTime(url) {
			const response = await this.$axios.get(url, {
				headers: {
					'User-Agent': 'Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.81 Safari/537.36 Edg/94.0.992.50',
				},
			});

			return (response.headers && response.headers.location) || url;
		},
		unshortRecursive(urls, options = {}, resolve, reject, depth = 0) {
			if (options.max_depth && options.max_depth === depth) {
				return resolve(urls);
			}

			const longUrl = urls[urls.length - 1];

			return this.unshortOneTime(longUrl, options)
				.then((unshortedUrl) => {
					if (unshortedUrl === longUrl) {
						resolve(urls);
					} else {
						urls.push(unshortedUrl);
						this.unshortRecursive(urls, options, resolve, reject, depth + 1);
					}
				})
				.catch((error) => {
					resolve({
						urls,
						error,
					});
				});
		},

		unshort(url, options = {}) {
			const urls = [];
			urls.push(url);

			return new Promise((resolve, reject) => {
				this.unshortRecursive(urls, options, resolve, reject);
			});
		},
	},
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>
